/**
 * Aba "Marca e rodapé": identidade do portal (sigla, cores, dateline, autor
 * padrão) e o rodapé de hora, atraso e fonte de cada bloco de dado.
 */
import type { PortalSiteDetalhe } from '@/types/portal';

import { CartaoSecao } from './CartaoSecao';
import { EditorMarca, EditorRodape } from './EditoresBloco';
import { validarMarca, validarRodape } from './validacao';

export function AbaMarcaRodape({ detalhe }: { detalhe: PortalSiteDetalhe }) {
  return (
    <div>
      <CartaoSecao
        siteId={detalhe.site_id}
        secao={detalhe.secoes.marca}
        titulo="Marca"
        resumo="Sigla, cores, dateline e autor padrão. Chegam ao site como propriedades CSS --wd-* e na dateline montada na hora de exibir."
        validar={validarMarca}
        abertoInicial
      >
        {(ctx) => <EditorMarca {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={detalhe.site_id}
        secao={detalhe.secoes.rodape}
        titulo="Rodapé dos blocos de dado"
        resumo="O que o leitor vê sob cada bloco: hora do dado, atraso e fonte, e o selo da plataforma uma vez por página."
        validar={validarRodape}
        abertoInicial
      >
        {(ctx) => <EditorRodape {...ctx} />}
      </CartaoSecao>
    </div>
  );
}
